// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fb-j";
export var fulfillmentFormRail = "_fb-i";
export var headerTitleRow = "_fb-l";
export var orderDetailsWrapper = "_fb-g";
export var orderLinkTrigger = "_fb-2";
export var paymentInformationGrid = "_fb-q";
export var paymentSummaryColumn = "_fb-r";
export var phoneShipmentPickerButton = "_fb-e";
export var phoneShipmentPickerButtonContent = "_fb-f";
export var phoneShipmentPickerButtonWrapper = "_fb-d";
export var phoneShipmentPickerTrigger = "_fb-c";
export var shipmentContainer = "_fb-k";
export var shipmentDetailsMainPane = "_fb-h";
export var shipmentNavigationCard = "_fb-a";
export var shipmentNavigationEdgeTrigger = "_fb-6";
export var shipmentNavigationRail = "_fb-3";
export var shipmentNavigationRailEnter = "_fb-5";
export var shipmentNavigationRailHeader = "_fb-9";
export var shipmentNavigationRailOverlay = "_fb-4";
export var shipmentNavigationScrim = "_fb-7";
export var shipmentSummaryFact = "_fb-n";
export var shipmentSummaryGrid = "_fb-m";
export var shipmentSummaryMetadataRow = "_fb-o";
export var shipmentSummaryTags = "_fb-p";
export var shipmentWorkspace = "_fb-0";
export var shipmentWorkspaceBodyTablet = "_fb-8";
export var shipmentWorkspaceContent = "_fb-b";
export var shipmentWorkspaceHeader = "_fb-1";